import { useStore } from '../lib/store.js';

export function Toasts() {
  const toasts = useStore((s) => s.toasts);
  return (
    <div className="toasts" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`toast${t.kind === 'ok' ? ' toast--ok' : t.kind === 'bad' ? ' toast--bad' : ''}`}>
          {t.text}
        </div>
      ))}
    </div>
  );
}
